import { select, fork, takeLatest, put, call } from 'redux-saga/effects';
import { getErrorMessageKey } from '../utils/helper';
import store from '../store';
import { addModal } from '../actions/modals';
import { PASSING } from '../actions/passing';
import { loadNextQuestion } from './../utils/Api';

function* loadQuestion({ id }) {
  try {
    const res = yield call(loadNextQuestion, id);
    if (res.question) {
      yield put({ type: PASSING.LOAD_QUESTION_DONE, lesson: { ...res } });
    } else if (res.error && res.error.msg && res.error.code === 3377) {
      window.location.href = `${window.location.href.split('/passing')[0]}/results`;
    } else {
      const { translations } = yield select(({ i18n }) => i18n);
      const message = res.error && (getErrorMessageKey(translations, res.error.code) || res.error.msg);
      store.dispatch(addModal(3, [message || 'next question error']));
      // TODO: use router here
      window.location.href = `${window.location.href.split('/passing')[0]}`;
    }
  } catch (message) {
    store.dispatch(addModal(3, [message]));
    // TODO: use router here
    window.location.href = `${window.location.href.split('/passing')[0]}`;
  }
}

export default function* passing() {
  yield [
    fork(function* () { yield takeLatest(PASSING.LOAD_QUESTION, loadQuestion); }),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/passing.js